import React from "react";
import config from "../../config";
import CloseButton from "../../components/CloseButton/CloseButton";

const CanDelete = (permission, role) => {
  const protectedPermissions = config.protectedPermissions.filter(
    protectedPermission => {
      return (
        protectedPermission.role === role.name &&
        protectedPermission.permission === permission.name
      );
    }
  );

  return protectedPermissions.length === 0;
};

const RemovePermission = ({ permission, role, onClick }) => {
  if (CanDelete(permission, role)) {
    return <CloseButton onClick={onClick} />;
  } else {
    return null;
  }
};

export default RemovePermission;



// WEBPACK FOOTER //
// ./src/containers/RolePage/RemovePermission.js